import { AxiosResponse } from 'axios';

import { HttpService } from '~system/api/base/http-service';

import { ApiForgotPasswordRequest } from '~shared/types';

export const forgotPassword = async (
  forgotPasswordData: ApiForgotPasswordRequest
) => {
  const { data }: AxiosResponse<null> = await HttpService.post(
    'lessor/auth/password/forgot',
    forgotPasswordData
  );

  return data;
};
